import { motion } from "framer-motion";
import { ShieldCheck, Users, Award } from "lucide-react";

const STATS = [
  { icon: Award, value: "20 years", label: "Leadership in Dubai real estate" },
  { icon: Users, value: "People-first", label: "Advisory built around your goals" },
  { icon: ShieldCheck, value: "RERA-verified", label: "Every step checked against DLD rules" },
];

export const About = () => (
  <section id="about" data-testid="about-section" className="py-20 lg:py-32">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
      <motion.div
        initial={{ opacity: 0, x: -32 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
      >
        <p className="text-xs uppercase tracking-[0.35em] text-gold-light/90 font-medium mb-6">Who we are</p>
        <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#F8F6F0] leading-tight">
          Two decades of quiet leadership, <span className="italic gold-text">one perfect haven</span> at a time.
        </h2>
        <p className="mt-7 text-sm sm:text-base text-zinc-300 leading-relaxed">
          Haven &amp; Hill pairs deep Dubai market insight with a people-first approach — helping buyers,
          sellers and investors move with confidence through a seamless, technology-driven process. From
          your first question to the moment the title deed carries your name, our advisors stay beside you.
        </p>
        <div className="mt-10 grid sm:grid-cols-3 gap-6">
          {STATS.map((s) => (
            <div key={s.label} className="gold-ring rounded-xl p-5 bg-ink-card/60 transition-colors">
              <s.icon size={20} className="text-gold mb-3" />
              <p className="font-serif text-lg text-gold-pale">{s.value}</p>
              <p className="text-xs text-zinc-400 mt-1 leading-relaxed">{s.label}</p>
            </div>
          ))}
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, x: 32 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="relative"
      >
        <div className="absolute -inset-4 gold-ring rounded-3xl rotate-2" />
        <div className="relative rounded-3xl overflow-hidden aspect-[4/5]">
          <img
            src="https://images.unsplash.com/photo-1782999492755-5d96d688a05f?crop=entropy&cs=srgb&fm=jpg&q=85"
            alt="Luxury Dubai waterfront penthouse lounge"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-transparent to-transparent" />
        </div>
      </motion.div>
    </div>
  </section>
);
